import React from 'react'

export const CharityPage = (): React.ReactElement => <h1>Charity page</h1>
